import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { CARD_HEADER_MIN_HEIGHT } from './quoteCardTypes'

/** A priced quote card's outline — carrier, price, a coverage per block — for a page still loading its quotes. */
export function PricedQuoteCardSkeleton() {
  return (
    <div className="bg-card/60 flex w-full flex-col gap-4 rounded-xl border p-4">
      <div className={cn('flex items-center gap-3', CARD_HEADER_MIN_HEIGHT)}>
        <Skeleton className="size-11 shrink-0 rounded-full" />
        <Skeleton className="h-5 w-32" />
      </div>
      <Skeleton className="h-9 w-48" />
      <Skeleton className="h-24 w-full rounded-lg" />
      <Skeleton className="h-24 w-full rounded-lg" />
      <Skeleton className="mx-auto h-4 w-24" />
    </div>
  )
}
